/* eslint-disable no-plusplus */
export const selectFilter = (products, filter) => {
  if (!products || products.length === 0) return [];

  const keyword = filter.keyword.toLowerCase();
  return products
    .filter((product) => {
      const isInRange = filter.maxPrice
        ? product.price >= filter.minPrice && product.price <= filter.maxPrice
        : true;
      const matchKeyword = product.keywords
        ? product.keywords.includes(keyword)
        : true;
      const matchName = product.name
        ? product.name.toLowerCase().includes(keyword)
        : true;
      const matchDescription = product.description
        ? product.description.toLowerCase().includes(keyword)
        : true;
      const matchRegion = product.address.region
        ? product.address.region.includes(filter.region)
        : true;
      const matchProvince = product.address.province
        ? product.address.province.includes(filter.province)
        : true;
      const matchNpa = product.address.npa
        ? product.address.npa.includes(filter.npa)
        : true;
      const matchType = product.category.type
        ? product.category.type.includes(filter.type)
        : true;
      const bikeSelection = 'Bicicletta';
      const matchSub1 = (() => {
        if (filter.type === bikeSelection) {
          if (product.category.sub1 && filter.sub1 !== '') {
            return product.category.sub1 === filter.sub1;
          }
        }
        return true;
      })();
      const matchYear = (() => {
        if (filter.type === bikeSelection) {
          if (product.category.year && filter.year !== '') {
            return product.category.year.toString() === filter.year;
          }
        }
        return true;
      })();
      const matchSize = (() => {
        if (filter.type === bikeSelection) {
          if (product.category.size && filter.size !== '') {
            return product.category.size.toString() === filter.size;
          }
        }
        return true;
      })();
      const matchBrand = (() => {
        if (filter.type === bikeSelection) {
          if (product.category.brand && filter.brand !== '') {
            return product.category.brand.toString() === filter.brand;
          }
        }
        return true;
      })();
      const matchAssisted = (() => {
        if (filter.type === bikeSelection) {
          if (product.category.assisted && filter.assisted !== '') {
            return product.category.assisted.toString() === filter.assisted;
          }
        }
        return true;
      })();
      const matchWeight = (() => {
        if (filter.type === bikeSelection) {
          if (product.category.weight && filter.weight !== '') {
            return product.category.weight.toString() === filter.weight;
          }
        }
        return true;
      })();
      const matchWheels = (() => {
        if (filter.type === bikeSelection) {
          if (product.category.wheels && filter.wheels !== '') {
            return product.category.wheels.toString() === filter.wheels;
          }
        }
        return true;
      })();

      return (
        (matchKeyword || matchDescription || matchName) &&
        matchRegion &&
        matchProvince &&
        matchNpa &&
        matchType &&
        matchSub1 &&
        matchYear &&
        matchSize &&
        matchBrand &&
        matchAssisted &&
        matchWeight &&
        matchWheels &&
        isInRange
      );
    })
    .sort((a, b) => {
      if (filter.sortBy === 'name-desc') {
        return a.name < b.name ? 1 : -1;
      }
      if (filter.sortBy === 'name-asc') {
        return a.name > b.name ? 1 : -1;
      }
      if (filter.sortBy === 'price-desc') {
        return a.price < b.price ? 1 : -1;
      }
      if (filter.sortBy === 'price-asc') {
        return a.price > b.price ? 1 : -1;
      }
      if (filter.sortBy === 'date-asc') {
        return a.dateAdded > b.dateAdded ? 1 : -1;
      }
      return a.dateAdded < b.dateAdded ? 1 : -1;
    });
};

export const selectMax = (products) => {
  if (!products || products.length === 0) return 0;

  let high = products[0];

  for (let i = 0; i < products.length; i++) {
    if (products[i].price > high.price) {
      high = products[i];
    }
  }

  return Math.floor(high.price);
};

export const selectMin = (products) => {
  if (!products || products.length === 0) return 0;
  let low = products[0];

  for (let i = 0; i < products.length; i++) {
    if (products[i].price < low.price) {
      low = products[i];
    }
  }

  return Math.floor(low.price);
};
